// @owners { team: patients-team }
import { createSelector } from 'reselect';
import { HAS_OTHER_SCRIPTS } from '~shared/constants';
import { getCurrentUser } from '~shared/features/users/selectors/getCurrentUser';

export const getUserHasOtherScripts = createSelector([getCurrentUser], (currentUser) => {
  return currentUser?.onboarding_other_scripts === HAS_OTHER_SCRIPTS;
});
